import type { ReactNode } from 'react';
import { selectViewport, useMindmapStore } from '../../store';

export type ViewportProps = { children?: ReactNode };

/** The transformed layer that holds edges and nodes; pan and zoom only change its CSS transform. */
export const Viewport = ({ children }: ViewportProps) => {
  const { x, y, zoom } = useMindmapStore(selectViewport);
  return (
    <div className="cm-viewport" style={{ transform: `translate(${x}px, ${y}px) scale(${zoom})` }}>
      {children}
    </div>
  );
};
